(function () {
  // Grille générique cage thoracique + bonnet -> taille générique (XS à XXL).
  // Approximation courante du marché ; à ajuster selon votre propre guide des tailles.
  var BAND_INDEX = { '30': 0, '32': 1, '34': 2, '36': 3, '38': 4, '40': 5, '42': 6, '44': 7 };
  var CUP_INDEX = { 'UN': 0, 'B': 1, 'C': 2, 'D': 3, 'DD/E': 4, 'DDD/F': 5, 'G': 6 };
  var SIZE_LADDER = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

  function computeBraSize(band, cup) {
    var bandIdx = BAND_INDEX.hasOwnProperty(band) ? BAND_INDEX[band] : 2;
    var cupIdx = CUP_INDEX.hasOwnProperty(cup) ? CUP_INDEX[cup] : 2;
    var total = bandIdx + cupIdx;
    var bucket = Math.floor(total / 2);
    if (bucket < 0) bucket = 0;
    if (bucket > SIZE_LADDER.length - 1) bucket = SIZE_LADDER.length - 1;
    return SIZE_LADDER[bucket];
  }

  function normalize(str) {
    return (str || '').toString().trim().toUpperCase();
  }

  function findSizeInput(targetSize) {
    var target = normalize(targetSize);

    var radios = document.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var input = radios[i];
      var name = input.getAttribute('name') || '';
      var fieldset = input.closest('fieldset');
      var legendText = fieldset ? (fieldset.querySelector('legend') || {}).textContent : '';
      var context = (name + ' ' + (legendText || '')).toLowerCase();

      if (context.indexOf('taille') === -1 && context.indexOf('size') === -1) continue;

      if (normalize(input.value) === target) return input;

      var label = document.querySelector('label[for="' + input.id + '"]');
      if (label && normalize(label.textContent) === target) return input;
    }

    var selects = document.querySelectorAll('select');
    for (var j = 0; j < selects.length; j++) {
      var select = selects[j];
      var selName = (select.getAttribute('name') || select.getAttribute('data-option-name') || '').toLowerCase();
      if (selName.indexOf('taille') === -1 && selName.indexOf('size') === -1) continue;
      var options = select.querySelectorAll('option');
      for (var k = 0; k < options.length; k++) {
        if (normalize(options[k].value) === target || normalize(options[k].textContent) === target) {
          return { select: select, option: options[k] };
        }
      }
    }

    return null;
  }

  function applySizeSelection(targetSize) {
    var match = findSizeInput(targetSize);
    if (!match) return false;

    if (match.select) {
      match.select.value = match.option.value;
      match.select.dispatchEvent(new Event('change', { bubbles: true }));
      return true;
    }

    match.checked = true;
    match.dispatchEvent(new Event('change', { bubbles: true }));
    match.dispatchEvent(new Event('click', { bubbles: true }));
    var label = document.querySelector('label[for="' + match.id + '"]');
    if (label) label.dispatchEvent(new Event('click', { bubbles: true }));
    return true;
  }

  function scrollToSizeInput(targetSize) {
    var match = findSizeInput(targetSize);
    var el = match ? (match.select || match) : null;
    if (!el) return;
    var container = el.closest('fieldset') || el;
    container.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function initSizeFinder(root) {
    var trigger = root.querySelector('[data-size-finder-trigger]');
    var panel = root.querySelector('[data-size-finder-panel]');
    var tabs = root.querySelectorAll('[data-size-tab]');
    var tabPanels = root.querySelectorAll('[data-size-tab-panel]');
    var resultBox = root.querySelector('[data-size-result]');
    var resultValue = root.querySelector('[data-size-result-value]');
    var resultBasis = root.querySelector('[data-size-result-basis]');
    var resultLink = root.querySelector('[data-size-result-link]');
    var resultLinkSize = root.querySelector('[data-size-result-link-size]');

    var currentSize = null;

    if (trigger && panel) {
      trigger.addEventListener('click', function () {
        var isOpen = !panel.hidden;
        panel.hidden = isOpen;
        trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      });
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        var target = tab.getAttribute('data-size-tab');
        tabPanels.forEach(function (p) {
          p.hidden = p.getAttribute('data-size-tab-panel') !== target;
        });
        resultBox.hidden = true;
      });
    });

    root.querySelectorAll('[data-size-group]').forEach(function (group) {
      var options = group.querySelectorAll('[data-size-option]');
      options.forEach(function (option) {
        option.addEventListener('click', function () {
          options.forEach(function (o) { o.classList.remove('is-selected'); });
          option.classList.add('is-selected');
        });
      });
    });

    function getSelectedValue(groupName, scope) {
      var el = scope.querySelector('[data-size-group="' + groupName + '"] .is-selected');
      return el ? el.getAttribute('data-value') : null;
    }

    root.querySelectorAll('[data-size-submit]').forEach(function (submitBtn) {
      submitBtn.addEventListener('click', function () {
        var mode = submitBtn.getAttribute('data-size-submit');
        var tabPanel = submitBtn.closest('[data-size-tab-panel]');
        var size, basisText;

        if (mode === 'bra') {
          var band = getSelectedValue('band', tabPanel);
          var cup = getSelectedValue('cup', tabPanel);
          if (!band || !cup) return;
          size = computeBraSize(band, cup);
          basisText = 'Basé sur un soutien-gorge ' + band + cup + '.';
        } else {
          var simple = getSelectedValue('simple', tabPanel);
          if (!simple) return;
          size = simple;
          basisText = 'Basé sur votre taille habituelle ' + simple + '.';
        }

        currentSize = size;
        resultValue.textContent = size;
        resultBasis.textContent = basisText;
        resultLinkSize.textContent = size;
        resultBox.hidden = false;
        resultBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

        applySizeSelection(size);
      });
    });

    if (resultLink) {
      resultLink.addEventListener('click', function (event) {
        event.preventDefault();
        if (!currentSize) return;
        applySizeSelection(currentSize);
        scrollToSizeInput(currentSize);
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-size-finder]').forEach(initSizeFinder);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-size-finder]');
    if (root) initSizeFinder(root);
  });
})();